module.exports = {
  title: 'Demand Medicare for All!',
  callToAction: 'Sign this petition',
  action: 'demand-medicare-for-all',
  actionTarget: `All members of congress`,
  actionCopy: `
    We demand a Medicare for All single payer system to finally guarantee health care as a
    human right - not a privilege. The House and Senate must pass the Medicare for All Act of 2019.
  `,
  content: `
    <p>44 million people in the US are uninsured. 38 million more are under insured. 45,000 people die each year due to lack of health insurance. We
    are facing a crisis in our country.</p>
    <p>For-profit, private health insurance corporations are price gouging us and denying us care to the point of debt, bankruptcy, and death. We
    all deserve better as our human right.</p>
    <p>We demand a Medicare for All single payer system. Medicare for All expands Medicare to cover everyone and guarantees comprehensive health
    care--including vision, dental, hearing, and long-term care.</p>
    <p>We demand a Medicare for All single payer system to finally guarantee health care as a human right - not a privilege. The Medicare for All
    Act of 2019 in the House and Senate must become law.</p>
  `,
  theme: {
    breakpoints: [`40em`, `52em`, `64em`],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
    colors: {
      lightBlue: `#2181ff`,
      blue: `#1f80ff`,
      darkBlue: `#0c53b1`,
      lightgray: `#f6f6ff`,
    },
    space: [0, 4, 8, 16, 32, 64, 128, 256],
    fonts: {
      body: `system-ui, sans-serif`,
      heading: `system-ui, sans-serif`,
      monospace: `Menlo, monospace`,
    },
    fontWeights: {
      body: 400,
      heading: 700,
      bold: 700,
    },
    lineHeights: {
      body: 1.5,
      heading: 1.25,
    },
    shadows: {
      small: `0 0 4px rgba(0, 0, 0, .125)`,
      large: `0 0 24px rgba(0, 0, 0, .125)`,
    },
    variants: {},
    text: {},
    buttons: {
      primary: {
        color: `white`,
        bg: `primary`,
      },
    },
  },
};
